import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from "vuetify/lib"
import { Ripple } from "vuetify/lib/directives"

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  directives: {
    Ripple
  }
});
